import { render, staticRenderFns } from "./EventApply.vue?vue&type=template&id=65853151&scoped=true"
import script from "./EventApply.vue?vue&type=script&lang=js"
export * from "./EventApply.vue?vue&type=script&lang=js"
import style0 from "./EventApply.vue?vue&type=style&index=0&id=65853151&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65853151",
  null
  
)

export default component.exports